module.exports = __webpack_public_path__ + "img/tickets.fd4cca84.png";